import '../App.scss';
import { useState, useEffect } from "react";

import LMIC from "../data/LMIC.json";

async function importCardData(textName) {
	const cardData = await import("../data/" + textName + "/" + textName);
	return cardData;
}
async function importTextCCData(textName) {
	const textCCData = await import("../data/" + textName + "/" + textName + "_CC");
	return textCCData;
}

export default function CardHighlight(props) {


	var textFolder = props.title; 
	textFolder = textFolder.replace(/\s+/g, '-')
		.replace(':', '_')
		.replace('/', '_')
		.replace("'", '_');
	const path = "/reviews/" + textFolder;

	const [cardData, setCardData] = useState(null);
	const [CCData, setCCData] = useState(null);

	useEffect(() => {
			if (textFolder) {
			importCardData(textFolder)
				.then((data) => setCardData(data))
				.catch((error) => console.error("Error loading text data:", error));

			importTextCCData(textFolder)
			.then((data) => setCCData(data))
			.catch((error) => console.error("Error loading CC data:", error));
			}
		}, [textFolder]);

	var blurb = "<i>Blurb coming soon.</i>"; 
	var title = "Title"; 
	var birdColor = "score-green";
	if (cardData) {
		title = cardData[0].propertyNameOriginal;
		if (cardData[0].mediaType == "serial") {
			title += " (Season " + cardData[0].mediaId + ")";
		}
		birdColor = calculateColor(calculateScore(cardData, CCData));

		if (cardData[0].pullQuoteFromBlurb) {
			blurb = cardData[0].pullQuoteFromBlurb;
		} else if (cardData[1] && cardData[1].pullQuoteFromBlurb){
			blurb = cardData[1].pullQuoteFromBlurb;
		} else {
			blurb = "<i>Quote forthcoming.</i>";
		}
	}


	var imgsrc = require("../data/" + textFolder + "/" + textFolder + ".jpg");

    return (
		<div className="card-highlight">
			<div className='flex-col gap-12'>
				<div className='flex-card gap-12 align-top'>
					<img src={imgsrc} alt="" className="card-highlight-image"></img>
					<div className="flex-col gap-12 gray-primary-text">
						<h1>{title}</h1>
						<div>
							<img src={require('./images/' + birdColor + '.png')} alt="bird scoring icon" className='score-bird'></img>
							<div className={'score-value ' + birdColor}>{calculateScore(cardData, CCData)}</div>
						</div>
					</div>
				</div>
				<p style={{ whiteSpace: 'pre-wrap' }} 
					dangerouslySetInnerHTML={{ __html: blurb}}/>
							
				<a href={path}><button className="button pink" to={"/"}>Read the review &gt;</button></a>
				

			</div>
		</div>
    )

}

function calculateColor(score) {
	// returns the bird type 
	if (score >= 50) {
		return ['score-green']
	} else if (score >= 43) {
		return 'score-yellow'
	} else if (score >= 36) {
		return 'score-orange'
	} else {
		return 'score-red'
	}
}

// returns an array of BR scores: [ethnicity, nationality, gender, sexualtiy, age]
function calculateBRScoreRev(reviewer) {
	if (reviewer) {
		var brE = reviewer.ethnicity ? reviewer.ethnicity : 0;
		var brN = reviewer.nationality ? reviewer.nationality : 0;
		var brG = reviewer.gender ? reviewer.gender : 0;
		var brS = reviewer.sexuality ? reviewer.sexuality: 0;
		var brA = reviewer.age ? reviewer.age : 0;
		return [brE*2, brN*2, brG*2, brS*2, brA*2];
	}
	return [];
}

// returns the average BR score
function calculateBRScore(textData) {	
	if (!textData) {
		console.error('Text data not found.', 0);
		return 0;
	}

	// CALCULATE BR SCORE 
	var brScoreT1 = calculateBRScoreRev(textData[0]);
	// console.log("tagger 1 br score: " + brScoreT1)

	var brScoreCombined = []
	
	if (textData[1]) {
		var brScoreT2 = calculateBRScoreRev(textData[1]);
		// console.log("tagger 2 br score: " + brScoreT2)
		
		for (let i = 0; i < 5; i++) {
			brScoreCombined[i] = Math.round((brScoreT1[i] + brScoreT2[i]) / 2);
		}
		// console.log("br score avg: " + brScoreCombined)
		return brScoreCombined.reduce((sum, v) => sum + v, 0)
	} 
	
	brScoreCombined = brScoreT1;
	return brScoreCombined.reduce((sum, v) => sum + v, 0)
}

// returns an array of CC scores: [ethnicity, nationality, gender, sexualtiy, age]
function calculateCCScoreRev(chars, genres) {
	if (chars !== new Set()) {
		var ccE = 0; 
		var ccN = 0;
		var ccG = 0; 
		var ccS = 0; 
		var ccA = 0;
		for (const c of chars) {

			// ETH CHECK: if (char NOT just white) OR (if (char = ethX, amg, unk) AND (cast NOT white)
			var eth = c.characterEthnicitySupertags; 
			if (eth.includes("asian pacific") || eth.includes("black") || eth.includes("indigenous") || eth.includes("latinx") || eth.includes("swana")) {
				ccE += 1; 
			} else if (eth.includes("ethnicity x") || eth.includes("ambiguous") || eth.includes("unknown")) {
				if (!c.actorEthnicitySupertags.includes("white")) {
					ccE += 1;
				}
			}

			// NAT CHECK: if LMIC 
			var nat = c.characterNationalitygeo;
			nat = nat.split('\n');
			for (var i = 0; i < nat.length; i++) {
				if (LMIC.countries.includes(nat[i])) {
					ccN += 1; 
					break;
				}
			}

			// GEN CHECK: if (char NOT cis man or man X)
			var gen = c.characterGenderSupertags;
			if (gen.includes("woman") || gen.includes("intersex") || gen.includes("nonbinary") || gen.includes("trans man")) {
				ccG += 1;
			} else if (gen.includes("unknown")) {
				if (!c.actorGenderSupertags.includes("cis man")) {
					ccG += 1;
				} 
			}

			// SEX CHECK: if (char NOT straight, pres straight, unk, ambg) OR (has queer subtext)
			var sex = c.characterSexualitySupertags;
			if (!sex.includes("straight") && !sex.includes("presumed straight") && !sex.includes("ambiguous") && !sex.includes("unknown")) {
				ccS += 1;
			} else if (c.characterSexualitySecondaryTags.includes("queer subtext")) {
				ccS += 1;
			}

			// AGE CHECK: if (char is over 50) OR (unknown and charZ is human and actor is over 50)
			var age = c.characterAge;

			if (age.includes("50-59") || age.includes("60-69") || age.includes("70-79") || age.includes("80-89") || age.includes("90-99")) {
				ccA += 1;
			} else if (age.includes("100+")) {
				if (genres && !genres.includes("fantasy") && !genres.includes("scifi"))
					ccA += 1
			} else if (age.includes("*") && c.characterz.includes("human")) {
				if (c.actorAge.includes("50-59") || c.actorAge.includes("60-69") || c.actorAge.includes("70-79") || c.actorAge.includes("80-89") || c.actorAge.includes("90-99") || c.actorAge.includes("100+")) {
					ccA += 1;
				}
			
			}


		}
		var ccScore = [ccE, ccN, ccG, ccS, ccA];
		// console.log(ccScore + " num chars: " + chars.size);
		ccScore.forEach((v, index, arr) => {
			arr[index] = Math.round((v/chars.size) * 10);
			// console.log(arr[index]);
		})
		// console.log("norm: " + ccScore);
		return ccScore;
	}
	return [];
}

// returns the average CC score
function calculateCCScore(textCCData, genres) {
	if (!textCCData) {
		console.error('Character and cast data not found.', 0);
		return 0;
	}

	var t1Chars = new Set();
	var t2Chars = new Set();
	var t1 = "";
	var t2 = "";

	for (let i = 0; i < textCCData.length; i++) {
		var c = textCCData[i];
		if (t1 === "") {
			t1 = c.tagger;
			t1Chars.add(c);
		} else if (t1 === c.tagger) {
			t1Chars.add(c);
		} else if (t2 === "") {
			t2 = c.tagger;
			t2Chars.add(c);
		} else if (t2 === c.tagger) {
			t2Chars.add(c);
		}
	}

	var ccScoreT1 = calculateCCScoreRev(t1Chars, genres);
	var ccScoreCombined = []

	if (t2Chars.size > 0) {
		var ccScoreT2 = calculateCCScoreRev(t2Chars, genres);
		for (let i = 0; i < 5; i++) {
			ccScoreCombined[i] = Math.round((ccScoreT1[i] + ccScoreT2[i]) / 2);
		}
		return ccScoreCombined.reduce((sum, v) => sum + v, 0)
	}

	ccScoreCombined = ccScoreT1;	
	return ccScoreCombined.reduce((sum, v) => sum + v, 0);

}

function calculateScore(textData, textCCData) {
	if (textData) {
		const newbrScore = calculateBRScore(textData);

		var genres = (textData[0].genres);
		if (textData[1]) {
			genres = genres.concat(textData[1].genres);
		}
		const newccScore = calculateCCScore(textCCData, genres);
	
		return newbrScore + newccScore
	}
	return 0;
}